import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {

    id?: number | string;
    name:any;
    subject: any;

};

export const updateProduct = ({ id, name,subject}: requestDTO) => {
  if(id){
    return axios.post(`/superadmin/update-product`, {id,  name,subject});
  }else{
    return axios.post(`/superadmin/create-product`, { name,subject});
  }
};

type UseAddUserOptions = {
  config?: MutationConfig<typeof updateProduct>;
};

export const useUpdateProduct = ({ config }: UseAddUserOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Product updated successfully',
      });
    },
    ...config,
    mutationFn: updateProduct,
  });
};
